import { FC } from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import makeStyles from '@mui/styles/makeStyles';
import { DeloitteButton } from './DeloitteButton';
import { DeloitteText } from './DeloitteText';

interface DeloitteInfoProps {
    title: string;
    subtitle?:string;
    text?: string;
    buttonLabel?: string;
    onClick?(): any;
}
const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: 300,
        fontSize: '3.8em'
    }, 
    subtitle: {
        fontWeight: 300,
        fontSize: '2.4em',
        color:theme.palette.text.secondary
    }
}));
export const DeloitteInfo: FC<DeloitteInfoProps> = (props) => {
    const { title, text, buttonLabel, onClick, children, subtitle } = props;
    const classes = useStyles();
    return (
        <Grid direction="row" container spacing={3} justifyContent="flex-start">
            <Grid xs={12}>
                <Typography className={classes.title}>{title}</Typography>
                {subtitle &&
                <Typography className={classes.subtitle}>{subtitle}</Typography>
                }
            </Grid>
            <Grid xs={12}>
                {text &&
                    <DeloitteText text={text} />
                }
                {children}
            </Grid>
            {buttonLabel && onClick &&
                <Grid xs={12}>
                    <DeloitteButton variant="contained" color="secondary" size="large" onClick={onClick} main cta>
                        {buttonLabel}
                    </DeloitteButton>
                </Grid>
            }
        </Grid>
    );
}